<div class="card">


    <!--  <div #qrContainer class="qr-display" *ngIf="object?.qrCodes">
        @for (item of object?.qrCodes; track $index) {
            <div class="qr-content">
            <qrcode 
                [qrdata]="item.code" 
                [width]="256" 
                [errorCorrectionLevel]="'M'"
                [colorDark]="'#ffffff'"
                [colorLight]="'#222222'"
                >
            </qrcode>
            <div class="code-text">{{ item.code }}</div>
            </div>
        }
    </div>
-->



    <div class="flex flex-col gap-6 items-center w-full" *ngIf="ready">

        <div class="w-full">

            <button class="button-elevation p-2 rounded-full" (click)="goBackToGames()">Tutte le avventure</button>
        </div>


        @if(form2Opts.formType == 'edit'){

        <div class="w-full shadow-medium p-4 rounded-3xl">
            <p class="text-2xl">Avventura</p>
            <app-dynamic-form #myForm [options]="form2Opts" [fields]="regConfig2" (resetData)="initializeForm()"
                (submit)="submit($event)">
            </app-dynamic-form>
        </div>

        @if(object){

        <div class="w-full shadow-medium p-4 rounded-3xl">
            <p class="text-2xl">Missioni</p>
            <app-gestione-missioni [idAdventure]="object.id"></app-gestione-missioni>
        </div>
        }

        }@else {

        <div class="w-full">

            <app-dynamic-form #myForm [options]="form2Opts" [fields]="regConfig2" (resetData)="initializeForm()"
                (submit)="submit($event)">
            </app-dynamic-form>
        </div>
        }


        <app-edit-history [data]="editHistoryData"></app-edit-history>


        <div class="card shadow-medium p-4 rounded-3xl w-full">
            <p class="text-2xl mb-4">QR codes</p>
            <div #qrContainer class="qr-display w-fit rounded-2xl p-2" style="background-color: #1e1e1e;" *ngIf="object?.qrCodes?.length">
                @for (item of object?.qrCodes; track $index; let i = $index) {
                <div class="qr-content flex flex-col items-center justify-center" style="background-color: #1e1e1e;">
                    <qrcode #qrComp [qrdata]="item.code" [width]="256" [errorCorrectionLevel]="'M'"
                        [colorDark]="'#F7F737'" [colorLight]="'#1e1e1e'" [elementType]="'canvas'">
                    </qrcode>

                    <div style="background-color: #1e1e1e;" class="code-text text-center"><b>{{ item.code }}</b></div>

                    <button type="button" [disabled]="loadingQrCode" class="btn button-elevation p-2 rounded-full my-2" (click)="downloadQR(i, item.code)">
                        <div>Scarica PNG</div>
                    </button>
                </div>
                }
            </div>
        </div>

    </div>
</div>